import { z } from "zod"

export const powurOsLoanDealerFeeSchema = z.object({
  id: z.number(),
  amount: z.number(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  loanFeeId: z.number(),
  externalId: z.string().nullable(),
  introPaymentFactor: z.number().nullable(),
  promoPaymentFactor: z.number().nullable(),
  secondPaymentWithIncentivesFactor: z.number().nullable(),
  secondPaymentWithoutIncentivesFactor: z.number().nullable(),
  roofPaymentFactor: z.number().nullable(),
  secondRoofPaymentWithoutIncentivesFactor: z.number().nullable(),
  paymentFactorsCalculated: z.string().nullable(),
})

export type PowurOsLoanDealerFee = z.infer<typeof powurOsLoanDealerFeeSchema>

export const powurOsLoanFeeSchema = z.object({
  id: z.number(),
  loanProviderId: z.number(),
  loanProvider: z.string(),
  term: z.number(),
  interestRate: z.number(),
  totalDealerFee: z.number(),
  currentDealerFee: z.number(),
  currentPowurMargin: z.number(),
  excludedRegions: z.string().nullable(),
  getExcludedRegions: z.array(z.string()),
  isPowurPreferred: z.boolean(),
  paymentFactorCalculatedDate: z.string().nullable(),
  escalatorRate: z.number().nullable().optional(),
  paymentFactor: z.number().nullable().optional(),
  customProviderActive: z.boolean().nullable().optional(),
})

export type PowurOsLoanFee = z.infer<typeof powurOsLoanFeeSchema>
